import './selection.css';
import '../search/search.css';
import '../listing/listing.css';
import '../illustration/illustration.css';
import '../biblio/biblio.css';
import '../dossier/dossier.css';
import '../dossier/dossier-titre.css';
import '../dossier/dossier-cartillu.css';
import '../dossier/dossier-somation.css';
import '../dossier/dossier-localisation.css';
import '../dossier/dossier-historique.css';
import '../dossier/dossier-description.css';
import '../dossier/dossier-actions.css';
import '../common/tablerixme.css';
import '../carousel/carousel.css';
import '../utils/utils.css';
import '../carto/carto.css';
import '../carto/ol-override.css';
import '../modal/modal.css';
import '../../node_modules/ol/ol.css';

import { init as initListing } from '../listing/listing.js';
import { getSelection, manageSelectionLinkInHeader } from './utils.js';

const urlParams = new URLSearchParams(window.location.search);
const start = Number.parseInt(urlParams.get('start') || '0');

const resultsContainer = document.querySelector('.search-results-list');
const searchUrl = resultsContainer.getAttribute('data-url');

let cleanListingState;
let currentTimeout;

// On créer une fonction temporaire afin de pouvoir récupérer le retour de fetchListing
(async () => {
  cleanListingState = await fetchListing();
})();
manageSelectionLinkInHeader();

document.addEventListener('selection:changed', () => {
  // On s'assure de ne pas rentrer dans cette fonction plusieurs fois en même temps
  if (currentTimeout) {
    window.clearTimeout(currentTimeout);
  }

  currentTimeout = setTimeout(async () => {
    cleanListingState?.();

    cleanListingState = await fetchListing();
  }, 300);
});

async function fetchListing() {
  const selectionData = getSelection();
  try {
    const headers = new Headers({
      'Content-Type': 'application/json',
      // Header custom pour indiquer qu'on ne souhaite pas récupérer une page complète
      'X-HTML-FRAGMENT': 'true',
    });
    const response = await fetch(searchUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        start,
        references: selectionData,
      }),
    });
    resultsContainer.innerHTML = await response.text();

    if (response.ok) {
      const { cleanState: cleanListingState } = initListing();

      const count = Object.keys(selectionData)
        .map((type) => selectionData[type].length)
        .reduce((currentCount, value) => currentCount + value, 0);
      document.querySelector(
        '.search-results-count',
      ).innerHTML = `${count} sélection${count > 1 ? 's' : ''}`;

      return cleanListingState;
    }
  } catch (error) {
    console.error(error);
    // TODO: Ajouter un message d'erreur côté UI ?
  }
  return null;
}
